import { gql } from 'apollo-boost';

export const FIND_FOLDERS = gql`
    query findFolders($data: FindFoldersInput!) {
        findFolders(data: $data) {
            folders {
                id
                title
                parent
                owner
                before
                isPinned
                pinnedRank
                path
                lastViewedAt
                lastMovedAt
                createdAt
                updatedAt
                deletedAt
                sharingStatus {
                    isShared
                    shareCount
                    isPublished
                }
            }
            cursor
        }
    }
`;
